module.exports = __webpack_public_path__ + "img/img_question_pop.8562129e.png";